import React, { FC } from 'react';

import { AuthPageWrapper } from '../AuthPageLayout';
import { LoginPage } from 'features';

/**
 * Define Login functional component to render the login page.
 *
 * This component uses the AuthPageWrapper component to wrap the LoginPage
 * and ensure that the page is rendered within the proper layout.
 *
 * @returns A React element representing the login page.
 */
export const Login: FC = () => {
  return (
    <AuthPageWrapper>
      <LoginPage />
    </AuthPageWrapper>
  );
};
